import { GetServerSidePropsContext, NextPageContext } from 'next';
import { COOKIES_CONFIG } from '@belong/common';
import { parseCookies } from 'nookies';
import { CoverageRegionModel } from 'src/api/models';
import { somewhereElse } from 'src/store/region';

export function getRegionFromCookies(
  ctx: NextPageContext | GetServerSidePropsContext,
  defaultRegion = somewhereElse,
) {
  const cookies = parseCookies(ctx);
  const regionCookie = cookies[COOKIES_CONFIG.REGION.name];

  let region = defaultRegion;

  if (regionCookie) {
    try {
      const storedregion = JSON.parse(regionCookie);
      if (storedregion.id !== 0) {
        region = storedregion;
      }
      const parsedValuesRegion: Record<string, unknown> = {};

      try {
        Object.entries(region).forEach(([key, val]) => {
          parsedValuesRegion[key] = JSON.parse(val as string);
        });

        region = parsedValuesRegion as unknown as CoverageRegionModel;
      } catch {
        // parse failed
      }
    } catch {
      // parse failed
    }
  }

  return region;
}
